import List from '.';
import { Space, Switch, Tooltip } from 'antd';
import { cutLongText, formatCurrency, formatCurrencyToExport } from '../../../services/utils';
import moment from 'moment';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';

export default function ControlStaffPage(props: any) {
    const [changeWasPaid, setChangeWasPaid] = useState<{ value: boolean, id: number } | undefined>(undefined);

    const calculateValue = (record: any, formatted = true) => {
        if (record.charge === 'driver') {
            if (formatted) {
                return formatCurrency(record.amount_charged || record.value || 0);
            }

            return record.amount_charged || record.value || 0;
        }

        let route = record?.staff?.relationships?.table?.relationships
            ?.routes?.find((route: any) =>
                route.from_zone_id === record?.pickup_zone_id
                && route.to_zone_id === record?.dropoff_zone_id
            );

        if (route) {
            let totalNumberOfPeople = (record?.number_adults || 0) + (record?.number_children || 0);

            let value = totalNumberOfPeople <= 4
                ? route?.pax14
                : (totalNumberOfPeople <= 8
                    ? route?.pax58
                    : 0);

            if (formatted) {
                return formatCurrency(value);
            }

            return value;
        }

        if (formatted) {
            return formatCurrency(0);
        }

        return 0;
    };

    const columns: any[] = [
        {
            title: 'Motorista', dataIndex: ['staff', 'data', 'name'], key: 'staff',  width: 120,
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
            title: 'Data', dataIndex: 'start', key: 'start', sorter: true,  width: 120,
            render: (_: any, record: any) => record.start ? moment(record.start, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
            title: 'Pick-up', dataIndex: 'pickup_location', key: 'pickup_location', 
            render: (_: any, record: any) => (cutLongText(record?.pickup_location, 20)),
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
            title: 'Drop-off', dataIndex: 'dropoff_location', key: 'dropoff_location', 
            render: (_: any, record: any) => (cutLongText(record?.dropoff_location, 20)),
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
            title: 'Cliente', dataIndex: ['booking', 'data', 'client_name'], key: 'client',
            render: (_: any, record: any) => cutLongText(record?.booking?.data?.client_name, 40),
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
            title: 'Valor', dataIndex: 'value', key: 'value', width: 120, 
            render: (_: any, record: any) => calculateValue(record),
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
            title: 'Pagamento', dataIndex: 'was_paid', key: 'was_paid', sorter: true, width: 170,
            render: (_: any, record: any) => {
                return (<Tooltip title={record.was_paid ? 'Cancelar confirmação' : 'Confirmar pagamento'}>
                    <Space direction={isMobile ? 'vertical' : 'horizontal'}>
                        <Switch checked={record.was_paid}
                            style={{ marginRight: 10 }}
                            onChange={(event: boolean) => {
                                setChangeWasPaid({ value: event, id: record.id });

                                record.was_paid = event;
                            }} />
                        {record.was_paid ? 'Pago' : 'Não Pago'}
                    </Space>
                </Tooltip>);
            },
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        }
    ];

    const label = 'Motoristas';
    const workerFilter = 'filter_staff_id';

    const onMapDataToExport = (data: any) => {
        let total = 0;

        const dados = data.map((service: any) => {
            total += calculateValue({
                ...service.data,
                ...service.relationships
            }, false);

            return {
                'ID': service.data.id,
                'Motorista': service?.relationships?.staff?.data?.name,
                'Data': service?.data?.start ? moment(service.data.start, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
                'Pick-up': service.data.pickup_location,
                'Drop-off': service.data.dropoff_location,
                'Cliente': service?.relationships?.booking?.data?.client_name,
                'Pagamento': service?.data?.was_paid ? 'Pago' : 'Não Pago',
                'Valor': formatCurrencyToExport(calculateValue({
                    ...service.data,
                    ...service.relationships
                }, false)),
            };
        });

        return dados.concat([{
            'ID': '',
            'Motorista': '',
            'Data': '',
            'Pick-up': '',
            'Drop-off': '',
            'Cliente': '',
            'Pagamento': 'TOTAL',
            'Valor': formatCurrencyToExport(total)
        }]);
    };

    return (
        <div className="content_page">
            <List
                type="staff"
                label={label}
                workerFilter={workerFilter}
                columns={columns}
                onMapDataToExport={onMapDataToExport}
                changeWasPaid={changeWasPaid}
                calculateValue={calculateValue} />
        </div>
    )
}
